import React from 'react';
import NumberFormat from 'react-number-format';

type Props = {
  amount: number;
};

const DollarAndCentsText = (props: Props) => {
  const { amount } = props;

  return <NumberFormat value={amount} displayType='text' thousandSeparator prefix='$' decimalScale={2} fixedDecimalScale />;
};

export default DollarAndCentsText;
